/**
 * Keep collection grids ordered as: available cards first, then out-of-stock.
 * Works for product cards and colorway cards (data-available on each .column).
 * Re-runs after filter AJAX and infinite/load-more appends so later pages
 * do not leave in-stock items below earlier OOS items.
 */
(function () {
  function isPromotionColumn(el) {
    return el.classList.contains('promotion-column');
  }

  function isProductColumn(el) {
    return el.classList.contains('column') && !isPromotionColumn(el);
  }

  function needsAvailabilitySort(productColumns) {
    let seenUnavailable = false;
    for (let i = 0; i < productColumns.length; i++) {
      const isAvailable = productColumns[i].getAttribute('data-available') !== 'false';
      if (!isAvailable) {
        seenUnavailable = true;
      } else if (seenUnavailable) {
        return true;
      }
    }
    return false;
  }

  function sortProductGridByAvailability(grid) {
    if (!grid) return;

    const children = Array.from(grid.children);
    const productColumns = children.filter(isProductColumn);
    if (productColumns.length < 2 || !needsAvailabilitySort(productColumns)) return;

    const available = [];
    const unavailable = [];

    productColumns.forEach((el) => {
      if (el.getAttribute('data-available') === 'false') {
        unavailable.push(el);
      } else {
        available.push(el);
      }
    });

    const sortedProducts = available.concat(unavailable);
    let productIndex = 0;
    const ordered = [];

    children.forEach((el) => {
      if (isPromotionColumn(el) || !isProductColumn(el)) {
        ordered.push(el);
        return;
      }
      if (productIndex < sortedProducts.length) {
        ordered.push(sortedProducts[productIndex]);
        productIndex += 1;
      }
    });

    while (productIndex < sortedProducts.length) {
      ordered.push(sortedProducts[productIndex]);
      productIndex += 1;
    }

    ordered.forEach((el) => {
      grid.appendChild(el);
    });
  }

  function sortAllCollectionGrids() {
    document.querySelectorAll('ul#product-grid.products.collection').forEach(sortProductGridByAvailability);
  }

  window.sortCollectionGridByAvailability = sortAllCollectionGrids;

  document.addEventListener('DOMContentLoaded', sortAllCollectionGrids);
  document.addEventListener('product-grid:updated', () => {
    requestAnimationFrame(sortAllCollectionGrids);
  });
  document.addEventListener('pagination:page-changed', () => {
    requestAnimationFrame(sortAllCollectionGrids);
  });
})();
